{
  "en": {
    "dashboard": {
      "greetings": {
        "afternoon": "Good afternoon {first_name}",
        "evening": "Good evening {first_name}",
        "morning": "Good morning {first_name}",
        "night": "Good night {first_name}"
      },
      "milestones": {
        "action_title_decision": "Choose {name}",
        "action_title_survey": "Take {name}",
        "action_title_ticket": "New message about {name}",
        "count_open": "{count} open",
        "journey_hide": "Hide project journey",
        "journey_show": "View project journey",
        "journey_step_active": "In progress",
        "journey_step_completed": "Completed",
        "journey_step_planned": "Planned",
        "other_empty_subtitle": "{client} will let you know as soon as something is waiting for you.",
        "other_empty_title": "You're all caught up",
        "other_promoted_title": "Needs your attention",
        "other_title": "Other actions",
        "stage_done_subtitle": "{client} will let you know when the next step comes.",
        "stage_done_title": "All done for this stage",
        "stage_empty": "Nothing to do in this stage right now.",
        "stage_eyebrow": "Current stage",
        "stage_final_subtitle": "Every step of your project is finished. We will keep you posted if anything changes.",
        "stage_final_title": "You're all done",
        "stage_last": "This is the final stage",
        "stage_next": "Up next: {phase}",
        "stage_position": "Stage {current} of {total}",
        "stage_todo_title": "To complete this stage"
      },
      "titles": {
        "activityFeed": "Activity Feed",
        "assignedTasks": "My Tasks",
        "newsFeed": "News Feed",
        "ongoingTickets": "Ongoing",
        "openTickets": "Open",
        "progress": "Progress",
        "tickets": "Conversations",
        "totalTickets": "All conversations",
        "unreadTickets": "Unread",
        "yourAssignedTickets": "Assigned to you"
      }
    }
  }
}
